"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentColor = exports.getHexFromTheme = exports.withCustomVerticalScrollbar = exports.flexUtils = void 0;
var theme_1 = require("../theme");
// Flex utils
exports.flexUtils = {
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
};
var withCustomVerticalScrollbar = function (color) {
    if (color === void 0) { color = '#c1c1c1'; }
    return ({
        '&::-webkit-scrollbar-track': {
            border: 0
        },
        '&::-webkit-scrollbar': {
            width: '6px'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: color
        },
        scrollbarWidth: 'thin',
        scrollbarColor: color + " transparent"
    });
};
exports.withCustomVerticalScrollbar = withCustomVerticalScrollbar;
var getHexFromTheme = function (inputTheme, color, shade) {
    var _a, _b, _c;
    if (color === void 0) { color = 'primary'; }
    if (shade === void 0) { shade = 500; }
    // @ts-ignore
    var themeShadedColor = (_b = (_a = inputTheme === null || inputTheme === void 0 ? void 0 : inputTheme.palette) === null || _a === void 0 ? void 0 : _a[color]) === null || _b === void 0 ? void 0 : _b[shade];
    if (!themeShadedColor) {
        // @ts-ignore
        return (_c = theme_1.DEFAULT_THEME.palette[color]) === null || _c === void 0 ? void 0 : _c[shade];
    }
    return themeShadedColor;
};
exports.getHexFromTheme = getHexFromTheme;
var getComponentColor = function (active, color, disabled, defaultValue) {
    if (defaultValue === void 0) { defaultValue = '#fff'; }
    if (disabled) {
        return '#c0c0c0';
    }
    if (active && color) {
        return color;
    }
    return defaultValue;
};
exports.getComponentColor = getComponentColor;
